module.exports = __webpack_public_path__ + "static/media/country-default.df7c6e1a.jpg";